import gql from "graphql-tag";

//---------------------------- HomePage Queries ---------------------------------

export const homepageQuery = gql`
  query homeQuery($alias: JSON, $lang: String, $location: String) {
    homepages(
      sort: "displayPosition:asc"
      where: { alias: $alias, kioskLocationCode_contains: $location }
      locale: $lang
    ) {
      id
      speech
      pageName
      locale
      alias
      pageType {
        ... on ComponentHomepageNavigation {
          __typename
          pathName
          pageHeader
        }
        ... on ComponentHomepageDialogBox {
          __typename
          textList
          type
          mapName
        }
      }
      displayIcon {
        id
        url
      }
    }
  }
`;

//---------------------------- Faq Page Queries ---------------------------------

export const faqCategoryQuery = gql`
  query faqCategoryQuery($lang: String, $category: String, $location: String) {
    faqCategories(
      sort: "displayOrder:asc"
      locale: $lang
      where: { categoryName: $category, kioskLocationCode_contains: $location }
    ) {
      id
      categoryName
      displayType
      displayOrder
      locale
    }
  }
`;

export const faqQuery = gql`
  query faqQuery($lang: String, $location: String) {
    faqs(
      start: 0
      locale: $lang
      where: { kioskLocationCode_contains: $location }
    ) {
      id
      category
      locale
      showMap
      mapName
      showQrcode
      qrDetails
      LinkID
      question
      answer
      linkKeyword
    }
  }
`;

export const faqQuery2 = gql`
  query faqQuery($lang: String, $location: String) {
    faqs(
      start: 100
      locale: $lang
      where: { kioskLocationCode_contains: $location }
    ) {
      id
      category
      locale
      showMap
      mapName
      showQrcode
      qrDetails
      LinkID
      question
      answer
      linkKeyword
    }
  }
`;

export const faqQuery3 = gql`
  query faqQuery($lang: String, $location: String) {
    faqs(
      start: 200
      locale: $lang
      where: { kioskLocationCode_contains: $location }
    ) {
      id
      category
      locale
      showMap
      mapName
      showQrcode
      qrDetails
      LinkID
      question
      answer
      linkKeyword
    }
  }
`;
//---------------------------- Map Page Queries ---------------------------------

export const floorQuery = gql`
  query floorQuery($lang: String, $location: String) {
    floors(
      sort: "floorNumber:ASC"
      locale: $lang
      where: { kioskLocationCode_contains: $location }
    ) {
      id
      floorName
      floorNumber
      speech
      defaultLocation
      locale
      inMapDisplay
      floorImage {
        id
        url
      }
    }
  }
`;

export const mapQuery = gql`
  query mapQuery($lang: String, $location: String) {
    maps(locale: $lang, where: { kioskLocationCode_contains: $location }) {
      id
      mapName
      mapFloor
      speech
      locale
      displayPosition
      showOnHomepage
      hearingLocationCode
      tower
      mapImage {
        id
        url
      }
    }
  }
`;
